
//Video Stuff
var players = {};
var insymaVideo = {
    createHTML5Video: function () {
        document.querySelectorAll("a.movielink[data-type='html5overlay']").forEach(function(link) {
            let content = "#overlayMovie_" + link.dataset.contentId;
            link.addEventListener("click", function(event) {
                event.preventDefault();
                console.log(content);
                // Assuming Fancybox has a plain JavaScript API
                Fancybox.show([
                    {
                        src: content,
                        type: 'inline'
                    }
                ]);
            });
        });
    },
    pauseAllFlashVideos: function (currentMovieId) {
        /*
        var videos = document.getElementsByTagName("object");
        for (i = 0; i < videos.length; i++) {
            videos[i].sendToActionScript("resetAll");
        }
        document.getElementById(currentMovieId).sendToActionScript("play");
        */
    },
    //Vimeo
    _isVimeoPaused: true,
    initVimeoVideos: function () {
        // Selektiere das Element mit der Klasse 'dataprivacy-info movie' innerhalb des body
        let content = document.querySelector("body > .dataprivacy-info.movie");
        // Selektiere alle Elemente mit dem Attribut 'data-movie-type' gleich 'vimeo'
        let vimeoElements = document.querySelectorAll("*[data-movie-type='vimeo']");
        // Iteriere über jedes Vimeo-Element
        vimeoElements.forEach(function(element) {
            let img = element.querySelector("img");
            if (img && img.getAttribute("src") === "") {
                var movieId = element.getAttribute("data-movie-id");
                var uri = "https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/" + movieId;
                // Erstelle einen JSONP-Request
                var script = document.createElement('script');
                script.src = uri + "&callback=handleVimeoResponse";
                document.body.appendChild(script);
                // Definiere die Callback-Funktion
                window.handleVimeoResponse = function(data) {
                    img.setAttribute("src", data.thumbnail_url);
                    document.body.removeChild(script);
                };
            }
        });
        // Event-Listener für Klicks auf Vimeo-Elemente
        document.body.addEventListener("click", function(event) {
            let target = event.target.closest("*[data-movie-type='vimeo']");
            if (target) {
                let clonedContent = content.cloneNode(true);
                // Öffne Fancybox
                new Fancybox([
                    {
                        src: sitePreviewState + insymaSiteConfig[siteLanguageCode][0]["contentMovieDataPrivacy"],
                        type: "ajax",
                        touch: false
                    },
                ],{
                    on: {
                        done: (fancybox, slide) => {
                            // Select the element with class 'dataprivacy-info' inside elements with classes 'fancybox-slide'
                            document.querySelectorAll('.fancybox__content .dataprivacy-info').forEach(function(element) {
                                element.classList.add('d-none');
                            });

                            // Select elements with data-id='vimeo' inside elements with class 'fancybox-slide'
                            document.querySelectorAll('.fancybox__content div[data-id="vimeo"]').forEach(function(element) {
                                element.classList.remove('d-none');
                                element.style.display = 'block'; // This is equivalent to jQuery's show()
                            });
                        }
                    }
                });
                // Event-Listener für den Abbrechen-Button
                clonedContent.querySelector(".btnCancel").addEventListener("click", function() {
                    Fancybox.close();
                });

                // Event-Listener für den Akzeptieren-Button
                clonedContent.querySelector(".btnAccept").addEventListener("click", function() {
                    Fancybox.close();
                    insymaVideo.createVimeoVideo(target);
                });
            }
        });
    },
    createVimeoVideo: function (obj) {
        let movie_id = obj.getAttribute("data-movie-id");
        let width = obj.getAttribute("data-width");
        let height = obj.getAttribute("data-height");
        let href = obj.getAttribute("data-href");
        new Fancybox([
            {
                src: href,
                type: "iframe",
                touch: false,
                width: width,
                height: height
            },
        ],{
            on: {
                done: (fancybox, slide) => {
                }
            }
        });
    },
    // Handle messages received from the player
    handleMessageVimeo: function (e) {
        let data;
        try { data = JSON.parse(e.data); } catch (e) { return false; }
        switch (data.event) {
            case 'ready': insymaVideo.vimeoOnReady(); break;
            case 'play': insymaVideo.vimeoOnPlay(data); break;
            case 'pause': insymaVideo.vimeoOnPause(data); break;
        }
    },
    postMessageVimeo: function (action, value) {
        /*
        let data = { method: action }, url;
        let $f = $('iframe[id^="iframe_movie_vimeo"]');
        if (value) { data.value = value; }
        $f.each(function (i, el) {
            url = $(el).attr('src').split('?')[0];
            el.contentWindow.postMessage(JSON.stringify(data), url);
        });*/
    },
    postSingleMessageVimeo: function (action, player_id) {
        /*
        let data = { method: action }, url;
        url = $("#" + player_id).attr('src').split('?')[0];
        $("#" + player_id).get(0).contentWindow.postMessage(JSON.stringify(data), url);
        */
    },
    pauseAllVimeoVideos: function (player_id) {
        /*
        let data = { method: 'pause' };
        let $f = $('iframe[id^="iframe_movie_vimeo"]');
        $f.each(function (i, el) {
            if (player_id != $(el).attr("id")) {
                var url = $(el).attr('src').split('?')[0];
                el.contentWindow.postMessage(JSON.stringify(data), url);
            }
        });
        */
    },
    vimeoOnReady: function () {
        insymaVideo.postMessageVimeo('addEventListener', 'play');
        insymaVideo.postMessageVimeo('addEventListener', 'pause');
        insymaVideo._isVimeoPaused = true;
    },
    vimeoOnPlay: function (data) {
        insymaVideo.pauseAllVimeoVideos(data.player_id);
        insymaVideo._isVimeoPaused = false;
    },
    vimeoOnPause: function (data) {
        insymaVideo._isVimeoPaused = true;
    },
    createVIMEOSplashscreen: function (vimeoId) {
        /*
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = "https://vimeo.com/api/v2/video/" + vimeoId + ".json?callback=insymaVideo.showVimeoSplashScreen";
        $("#vimeoimg-" + vimeoId).before(script);
        */
    },
    showVimeoSplashScreen: function (data) {
        /*
        let id_img = "#vimeo-" + data[0].id;
        if ($("#vimeoimg-" + data[0].id).attr("src") == "") { //Set image if there is no custom image defined
            $("#vimeoimg-" + data[0].id).attr('src', data[0].thumbnail_large);
            $("#vimeoimg-" + data[0].id).closest("a").css('background-image', "url(" + data[0].thumbnail_large) + ");";
        }
        */
    },
    //YOUTUBE
    initYoutubeVideos: function () {
        document.body.addEventListener('click', function(event) {
            let target = event.target.closest('*[data-movie-type="youtube"]');
            if (target) {
                let $this = target;
                // Öffne Fancybox
                new Fancybox([
                    {
                        src: sitePreviewState + insymaSiteConfig[siteLanguageCode][0]["contentMovieDataPrivacy"],
                        type: "ajax",
                        touch: false
                    },
                ],{
                    on: {
                        done: (fancybox, slide) => {
                            // Select the element with class 'dataprivacy-info' inside elements with classes 'fancybox-slide'
                            document.querySelectorAll('.fancybox__content .dataprivacy-info').forEach(function(element) {
                                element.classList.add('d-none');
                            });

                            // Select elements with data-id='vimeo' inside elements with class 'fancybox-slide'
                            document.querySelectorAll('.fancybox__content div[data-id="youtube"]').forEach(function(element) {
                                element.classList.remove('d-none');
                                element.style.display = 'block'; // This is equivalent to jQuery's show()
                            });
                            // Event-Listener für den Abbrechen-Button
                            document.body.querySelector(".btnCancel").addEventListener("click", function() {
                                Fancybox.close();
                            });

                            // Event-Listener für den Akzeptieren-Button
                            document.body.querySelector(".btnAccept").addEventListener("click", function() {
                                Fancybox.close();
                                insymaVideo.createYoutubeVideo($this);
                            });
                        }
                    }
                });

            }
        });
        document.querySelectorAll("a[data-type='youtubeinline']").forEach(function(element) {
            element.addEventListener("click", function() {
                var _id = this.getAttribute("data-content-id");
                insymaVideo.createYoutubeVideoInside(_id, this);
                /*
                if (CookieManager.getCookie(insyma_cookiepolicy_movies_yt)) {
                  // Hide the element
                  this.style.display = "none";
                  // Create YouTube video
                  insymaVideo.createYoutubeVideoInside(_id);
                } else {
                  // Create and open a modal (simplified version of Fancybox)
                  openPrivacyModal(_id, this);
                }*/
            });
        });
    },
    createYoutubeVideo: function (obj) {
        let movie_id = obj.getAttribute("data-movie-id");
        let width = obj.getAttribute("data-width");
        let height = obj.getAttribute("data-height");
        let href = obj.getAttribute("data-href");
        new Fancybox([
            {
                src: href,
                type: "iframe",
                touch: false,
                width: width,
                height: height
            },
        ],{
            on: {
                done: (fancybox, slide) => {
                }
            }
        });
    },
    createYoutubeVideoInside: function (aId, aThis) {
        aThis.style.display = "none";
        document.getElementById("frame_div_" + aId).style.display = "block";
        // Get the iframe element
        const iframe = document.getElementById("iframe_movie_youtube_" + aId);
        // Get the data-src attribute value
        const dataSrc = iframe.getAttribute("data-src");
        // Set the src attribute to the value from data-src
        iframe.setAttribute("src", dataSrc);
    },
    openPrivacyModal: function (videoId, clickedElement) {
      // Create modal container
      const modal = document.createElement("div");
      modal.className = "privacy-modal";
      modal.style.position = "fixed";
      modal.style.top = "0";
      modal.style.left = "0";
      modal.style.width = "100%";
      modal.style.height = "100%";
      modal.style.backgroundColor = "rgba(0, 0, 0, 0.7)";
      modal.style.display = "flex";
      modal.style.justifyContent = "center";
      modal.style.alignItems = "center";
      modal.style.zIndex = "9999";

      // Create modal content
      const modalContent = document.createElement("div");
      modalContent.className = "modal-content";
      modalContent.style.backgroundColor = "#fff";
      modalContent.style.padding = "20px";
      modalContent.style.borderRadius = "5px";
      modalContent.style.maxWidth = "500px";
      
      // Fetch privacy content
      fetch(sitePreviewState + insymaSiteConfig[siteLanguageCode][0]["contentMovieDataPrivacy"])
        .then(response => response.text())
        .then(html => {
          modalContent.innerHTML = html;
          
          // Hide data privacy info
          const dataPrivacyInfo = modalContent.querySelector(".dataprivacy-info");
          if (dataPrivacyInfo) dataPrivacyInfo.style.display = "none";
          
          // Show YouTube section
          const youtubeSection = modalContent.querySelector("div[data-id='youtube']");
          if (youtubeSection) youtubeSection.style.display = "block";
          
          // Add event listeners to buttons
          const cancelButton = modalContent.querySelector(".btnCancel");
          if (cancelButton) {
            cancelButton.addEventListener("click", function() {
              document.body.removeChild(modal);
            });
          }
          
          const acceptButton = modalContent.querySelector(".btnAccept");
          if (acceptButton) {
            acceptButton.addEventListener("click", function() {
              console.log(insyma_cookiepolicy_movies_yt);
              CookieManager.setCookie(insyma_cookiepolicy_movies_yt, "set", 1);
              document.body.removeChild(modal);
              clickedElement.style.display = "none";
              insymaVideo.createYoutubeVideoInside(videoId);
            });
          }
        })
        .catch(error => {
          console.error("Error loading privacy content:", error);
          modalContent.innerHTML = "<p>Error loading privacy content</p>";
        });
      
      modal.appendChild(modalContent);
      document.body.appendChild(modal);
    }
};

window.addEventListener("load", function(evt) {
    //********************************************
    // Video Handling
    //********************************************
    //HTML5 Video Stuff
        insymaVideo.createHTML5Video();
    //Vimeo
        insymaVideo.initVimeoVideos();
    //Youtube
        insymaVideo.initYoutubeVideos();
});